import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, TS_Checkbox, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import './Base_RequestMessageComposer.scss';
import { exists, isValidJson, prettifyJson } from '@nu-art/ts-common';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
const ViewMode_Composer = 'composer';
const ViewMode_Structured = 'structured';
export class Base_RequestMessageComposer extends ComponentSync {
    __onTemplateSelected(template) {
        this.reDeriveState({
            selectedTemplate: template,
            templateString: undefined
        });
    }
    deriveStateFromProps(nextProps, state) {
        state.templateString ??= state.selectedTemplate?.content ?? '';
        //if can't auto-add properties or prettify, fail-fast
        if (!isValidJson(state.templateString)) {
            const stringified = prettifyJson(state.templateString);
            if (!isValidJson(stringified))
                return state;
            state.templateString = stringified;
        }
        let templateObject = JSON.parse(state.templateString);
        templateObject = this.addPropertiesAtDeriveState(templateObject);
        state.templateString = prettifyJson(templateObject);
        return state;
    }
    addPropertiesAtDeriveState(templateObject) {
        return templateObject;
    }
    _sendRequest = async () => {
        if (this.state.templateString.length === 0) {
            this.logError('Can\'t send empty orders');
            return;
        }
        try {
            await this.sendRequest(this.state.templateString);
        }
        catch (err) {
            this.props.module.addErrorMessageToHistory(`Failed to send message:\n${err}`);
        }
    };
    onClear = () => this.reDeriveState({ selectedTemplate: undefined, templateString: undefined });
    onReset = () => this.reDeriveState({ templateString: this.state.selectedTemplate?.content ?? undefined });
    renderStructuredView() {
        return undefined;
    }
    hasStructuredView = () => {
        return !!this.renderStructuredView();
    };
    getViewMode = () => {
        return this.state.isStructured ? ViewMode_Structured : ViewMode_Composer;
    };
    renderToggleModeCheckbox = () => {
        if (!this.hasStructuredView())
            return '';
        return _jsx(TS_Checkbox, { checked: this.state.isStructured, onCheck: status => this.reDeriveState({ isStructured: status }), children: "Toggle Structure Mode" });
    };
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'match_width flex__space-between', children: [_jsx("div", { className: 'order-request-message-composer__title', children: `Request ${exists(this.state.selectedTemplate) ? `- ${this.state.selectedTemplate?.label}` : ''}` }), this.renderHeaderTail()] });
    };
    renderHeaderTail = () => {
        return undefined;
    };
    render() {
        const validJson = isValidJson(this.state.templateString);
        const className = _className('order-request-message-composer', !this.state.isStructured && 'order-request-message-composer__background', (validJson && !this.state.isStructured) ? 'valid-json' : 'invalid-json');
        return _jsx("div", { className: 'order-request-message-composer__container', children: _jsxs(LL_V_L, { className: className, children: [this.renderHeader(), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                            {
                                key: ViewMode_Composer,
                                renderer: () => _jsx(TS_TextArea, { className: 'template-content', value: this.state.templateString, onChange: value => this.reDeriveState({ templateString: value }), type: 'text' })
                            },
                            {
                                key: ViewMode_Structured,
                                renderer: () => this.renderStructuredView()
                            }
                        ] }), _jsxs(LL_H_C, { className: 'action-buttons', children: [this.renderToggleModeCheckbox(), _jsx(Button, { variant: 'secondary', onClick: this.onClear, children: "Clear" }), _jsx(Button, { variant: 'secondary', onClick: this.onReset, children: "Reset" }), _jsx(Button, { variant: 'primary', onClick: this._sendRequest, children: "Send" })] })] }) });
    }
}
//# sourceMappingURL=Base_RequestMessageComposer.js.map